import { useGetSmartSearchFrequentQuestions } from '~/hooks/smart-search';
import { useSmartSearchStore } from '~/store/common';

import SmartSearchQuestionList from './SmartSearchQuestionList';

const SmartSearchFAQ = () => {
  const { data: questions } = useGetSmartSearchFrequentQuestions();
  const { submitSearch, setInputValue } = useSmartSearchStore((state) => state.actions);

  if (!questions || questions.length === 0) return null;

  const handleClickQuestion = (question: string) => {
    setInputValue(question);
    submitSearch(question);
  };

  return (
    <SmartSearchQuestionList
      title="자주 묻는 질문"
      questions={questions.map((item) => ({ key: item.question, question: item.question }))}
      onClickQuestion={handleClickQuestion}
    />
  );
};

export default SmartSearchFAQ;
